<app-filter-header title="Filtrar Carrers" i18n-title  (apply)="this.apply()" (reset)="this.reset()" (dismiss)="this.dismiss()"></app-filter-header>
<div class="modal-body">
  <div class="row">
    <app-form-text-edit id="carrer-filter-codi" class="col-md-3" i18n-label label="Codi" [(value)]="filter.id" number maxLenght="7"></app-form-text-edit>
    <app-form-combo-edit class="col-md-3" label="Sigles" i18n-label class="col-sm-4" [items]="this.sigles" [(value)]="filter.sigles" valueField="id" textField="id"></app-form-combo-edit>
    <app-filter-text-edit id="carrer-filter-nom" class="col-sm-3" i18n-label label="Nom Carrer" [(value)]="filter.nomCarrer" maxLenght="250"></app-filter-text-edit>
  </div>
</div>

